import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OptionsModalEnum } from 'src/app/common/options-modal';
import { DateUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ExpenseResponse } from 'src/app/models/expense.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { EditCategoryVendorRequest } from 'src/app/models/vendor.model';
import { ExpenseService } from 'src/app/services/expense.service';
import { PpeService } from 'src/app/services/ppe.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-history-ppe',
  templateUrl: './history-ppe.component.html',
  styleUrls: ['./history-ppe.component.scss']
})
export class HistoryPpeComponent {
 creating = false;
  expenses: any = []
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  search = "";
  startDate = '';
  endDate = '';
  isAscendent = 0;
  editing: { [key: number]: InputAutocompleteModel } = {};
  buttonEditCategory: ButtonLoading = new ButtonLoading("btn-success", false, "", "fa-save");
  deleting: { [key: number]: any } = {};
  toDelete = null;
  reason = "";
  questionForModal = null;
  total = 0;
  detailing: { [key: string]: boolean } = {};
  moving: { [key: string]: boolean } = {};

  month = null;
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "REGISTRAR", "fa-save");

  constructor(
    private expenseService: ExpenseService,
    private toastService: ToastrService,
    private vendorService: VendorService,
    private ppeService: PpeService
  ) {
    var today = new Date();
    this.endDate = today.toLocaleDateString('en-CA');
    today.setDate(1);
    this.startDate = today.toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.getSavedItems();
  }


  getSavedItems() {
    this.ppeService.getSavedItems().subscribe({
      next: (response: ResponseObject) => {
        this.expenses = response.data;
        this.pagination.total = this.expenses;
        console.log(this.expenses);
        this.resetPagination();
        this.searching();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  showModalOption(expense) {
    this.toDelete = expense;
  }


  searching() {
    this.total = 0;
    this.pagination.total = this.expenses.filter((expense) => {
      this.total += expense.total;
      return this.matchValue(expense, this.search)
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  matchValue(element, value: any) {
    return element.code.toLowerCase() == value.toLowerCase() ||
      element.name.toLowerCase() == value.toLowerCase() ||
      element.asignedName.toLowerCase() == value.toLowerCase() ||
      element.localizationName.toLowerCase().includes(value.toLowerCase());
  }

  checkDateValue() {
    if (this.startDate && this.endDate) {
      //this.getExpenses();
    }
  }

  editCategory(expense) {
    if (this.editing[expense.id]) {
      return;
    }
    var added: { [key: number] : any} = {}
    this.vendorService.getCategoriesVendor(expense.vendorId).subscribe({
      next: (response: ResponseObject) => {
        this.editing[expense.id] = new InputAutocompleteModel(expense.category, true, true, "", "fa-circle-check", "danger", "danger", null, response.data);
        response.data.forEach(detail => {
          added[detail.id] = detail;
        });
        this.vendorService.getAllCategoriesVendor().subscribe({
          next: (response: ResponseObject) => {
            response.data.forEach(detail => {
              added[detail.id] = detail;
            });
            var temp = Object.values(added);
            this.editing[expense.id].total = temp;
            this.editing[expense.id].filterElements = temp;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        })
        //this.editing[expense.id].total = response.data;

      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  writeCategory(input: InputAutocompleteModel) {
    input.filterElements = input.total.filter((category) => {
      return category.name.toLowerCase().includes(input.value.toLowerCase())
    })
    input.verified = false;
    input.data = null;
    if (input.filterElements.length == 0) {
      input.class = "fa-circle-plus text-info";
      input.bgColor = "for-info";
      return;
    }
    input.class = "fa-list";
  }

  selectCategory(category, input: InputAutocompleteModel) {
    input.value = category.name;
    input.class = "fa-circle-check";
    input.verified = true;
    input.data = category;
  }

  tempCategory: { input: any, categoryName: any, expense: any } = null;


  detailingInvoice(invoice) {
    if (this.detailing[invoice.id]) {
      return;
    }
    this.detailing[invoice.id] = true;
  }


  movingToWarehouse(invoice) {
    if (this.moving[invoice.id]) {
      return;
    }
  }

  registerDepreciation() {
    if(this.month != null){
      const dateString = this.month;
      const date = new Date(`${dateString}-01T00:00:00`);

      this.ppeService.registerDepreciation(date.getTime()).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Depreciacion registrada con exito");
          this.getSavedItems();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      })
    }else{
      this.toastService.error("Necesita ingresar un mes para registrar la depreciacion");
    }
  }
  
}
